'use strict';

import React, { Component } from 'react';
import WebcamCapture from './WebcamCapture';
import ipLocation from 'iplocation';
import publicIp from 'public-ip';
import DummyPhoto from '../../images/icons/dummy_image.png';
import Verified from '../../images/icons/check.svg';
import './WebCapture.css';

class Selfie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      longitude: '',
      latitude: ''
    };
  }

  componentDidMount = () => {
    let currentComponent = this;
    var successHandler = function(position) {
      currentComponent.setState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      });
    };

    var errorHandler = function(errorObj) {
      // alert(errorObj.code + ': ' + errorObj.message);

      (async () => {
        let a = await ipLocation(await publicIp.v4());
        currentComponent.setState({
          latitude: a.latitude,
          longitude: a.longitude
        });
      })();
    };

    navigator.geolocation.getCurrentPosition(successHandler, errorHandler, {
      enableHighAccuracy: true,
      maximumAge: 10000
    });
  };

  render() {
    const elements = ['one', 'two', 'three'];

    const items = [];

    for (const [index, value] of elements.entries()) {
      items.push(
        <div className=" w-full mx-auto block mt-6" key={index}>
          <div className="flex mx-auto w-10/12">
            <div className="block w-6/12 mx-auto">
              <img className="w-8/12 " src={DummyPhoto} />
              <p className="w-8/12 text-left text-base text-grey-920 text-center">
                PAN
              </p>
            </div>
            <img className="w-8 float-right ml-16" src={Verified} />
          </div>
        </div>
      );
    }

    return (
      <div
        className="bg-white w-11/12 mx-auto md:w-full hidden md:block"
        id="selfie_main_container"
      >
        <div className="w-full mt-5 md:0 shadow-md mx-auto  py-5">
          <div className="w-full text-center mx-auto hidden md:block ">
            <h1 className="text-base font-khand font-medium">
              (Face Recognition)
            </h1>
          </div>
          <div className="w-full text-center mt-2 mx-auto  md:block">
            <h1 className="text-sm font-roboto font-normal text-grey-350 hidden md:block">
              Switch on Your Web Camera
            </h1>
            <div className="w-full mt-10">
              <WebcamCapture
              // componentHandler={this.props.componentHandler}
              />
              <div className="block md:hidden mt-3">
                <h1 className="text-lg font-roboto font-bold text-grey-920 text-center">
                  Current Photo
                </h1>
                <p className="text-sm font-roboto font-bold text-grey-920 text-right mt-6 mr-3">
                  GEO Location : &nbsp; {this.state.latitude},{' '}
                  {this.state.longitude}{' '}
                </p>
                <p className="text-sm font-roboto font-normal text-grey-920 text-right mt-6 mr-3">
                  {' '}
                  4.8 km from Current Home Address{' '}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="block md:hidden">
          <div className="">
            <p className="text-base font-roboto font-bold text-center mt-6 text-grey-920">
              Current photo matched with :
            </p>
            {items}
          </div>
          <div className=" w-full ">
            <div className="w-8/12 mx-auto mt-10">
              <progress className="w-full " value="85" max="100">
                {' '}
              </progress>
              <div className="w-full mx-auto flex mt-6 text-center">
                <p className="text-center  ml-auto text-xs font-roboto font-bold text-grey-920">
                  Matched 85%
                </p>
                <img className="w-4  mr-auto" src={Verified} />
              </div>
            </div>
          </div>
          <div className="w-full">
            <button
              type="submit"
              className="mx-auto text-xs bg-green-600  py-2 rounded mt-4 text-white font-roboto"
              // onClick={() => this.props.componentHandler(7)}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Selfie;
